import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

export class ViewAnnotationsButton extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'num-annotations': `number`,
    };
  }

  get config() {
    return {
      css,
      useShadowDom: true,
      template,
    };
  }
}

export const ViewAnnotationsButtonEl = defineAndMakeJsxFactory(`view-annotations-button`, ViewAnnotationsButton);
export const ViewAnnotationsButtonReact = panel2react(`view-annotations-button`, ViewAnnotationsButton);
